<div *ngIf="!hideLabel" class="label" [style.width.px]="labelWidth">
  <ng-container *ngTemplateOutlet="labelValueTemplate || defaultLabelValueTemplate; context: { percent: percentageWidth }"></ng-container>
</div>
<div class="percentage-bar">
  <div *ngIf="percentageWidth" [class]="type" [style.background-color]="color" [style.width.%]="percentageWidth * 100">
  </div>
  <ng-container *ngIf="percentageList">
    <div *ngFor="let percentage of percentageList" [class]="type" [style.width.%]="percentage.percent * 100"
      [style.background]="percentage.color"></div>
  </ng-container>
</div>

<ng-template #defaultLabelValueTemplate>
  {{ label ?? (percentageWidth | percent:decimalPoints) }}
</ng-template>
